import React from 'react';
import { 
  Instagram, 
  Facebook, 
  Mail, 
  Phone, 
  MapPin, 
  Heart,
  ExternalLink,
  Palette,
  Award,
  User,
  Calendar
} from 'lucide-react';
import './Footer.css';

const Footer = ({ artistProfile, onContactClick, onSectionClick }) => {
  const currentYear = new Date().getFullYear();

  const handleSmoothScroll = (sectionId) => {
    if (onSectionClick) {
      onSectionClick(sectionId);
    }
  };

  return (
    <footer className="premium-footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <div className="footer-logo-container" onClick={() => handleSmoothScroll('artworks')}>
              <img src="/logo.png" alt="My Musing Logo" className="footer-logo" />
              <div className="footer-brand-text">
                <h3>MY MUSING</h3>
                <p>ART AND CREATIONS</p>
              </div>
            </div>
            <p className="footer-description">
              Transforming imagination into captivating visual experiences. 
              Explore a world of artistic excellence and creative expression.
            </p>
            <div className="footer-social-links">
              {artistProfile?.instagram && (
                <a 
                  href={artistProfile.instagram} 
                  className="footer-social-link instagram"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Visit our Instagram"
                >
                  <Instagram size={20} />
                </a>
              )}
              {artistProfile?.facebook && (
                <a 
                  href={artistProfile.facebook} 
                  className="footer-social-link facebook"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Visit our Facebook"
                >
                  <Facebook size={20} />
                </a>
              )}
              <button 
                onClick={onContactClick}
                className="footer-social-link mail"
                aria-label="Contact us"
                type="button"
              >
                <Mail size={20} />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-section-title01">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <button 
                  onClick={() => handleSmoothScroll('artworks')}
                  className="footer-link"
                  type="button"
                >
                  <Palette size={16} />
                  <span>Gallery</span>
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleSmoothScroll('artist')}
                  className="footer-link"
                  type="button"
                >
                  <User size={16} />
                  <span>About Artist</span>
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleSmoothScroll('achievements')}
                  className="footer-link"
                  type="button"
                >
                  <Calendar size={16} />
                  <span>Achievements</span>
                </button>
              </li>
              <li>
                 <button 
                  onClick={() => handleSmoothScroll('exhibitions')}
                  className="footer-link"
                  type="button"
                >
                  <Award size={16} />
                  <span>Exhibitions</span>
                </button>
              </li>
              <li>
                <a 
                  href="/artist-login" 
                  className="footer-link"
                >
                  <ExternalLink size={16} />
                  <span>Artist Portal</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-section-title">Get in Touch</h4>
            <ul className="footer-contact">
              {artistProfile?.email && (
                <li className="footer-contact-item">
                  <Mail size={16} className="footer-contact-icon" />
                  <a href={`mailto:${artistProfile.email}`}>
                    {artistProfile.email}
                  </a>
                </li>
              )}
              {artistProfile?.phone && (
                <li className="footer-contact-item">
                  <Phone size={16} className="footer-contact-icon" />
                  <a href={`tel:${artistProfile.phone}`}>
                    {artistProfile.phone}
                  </a>
                </li>
              )}
              {artistProfile?.location && (
                <li className="footer-contact-item">
                  <MapPin size={16} className="footer-contact-icon" />
                  <span>{artistProfile.location}</span>
                </li>
              )}
            </ul>
            <button 
              onClick={onContactClick}
              className="footer-contact-btn"
              type="button"
            >
              <Mail size={18} />
              <span>Commission Art</span>
            </button>
          </div>

          {/* Newsletter/CTA */}
          <div className="footer-section">
            <h4 className="footer-section-title">Stay Connected</h4>
            <p className="footer-newsletter-text">
              Follow us on social media to see the latest artworks and behind-the-scenes content.
            </p>
            {/* <div className="footer-cta-buttons">
              <button 
                onClick={onContactClick}
                className="footer-cta-primary"
                type="button"
              >
                <Heart size={18} />
                <span>Start Your Commission</span>
              </button>
            </div> */}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} My Musing. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <button 
                // onClick={onContactClick}
                className="footer-bottom-link"
                type="button"
              >
                Privacy Policy
              </button>
              <span className="footer-divider">•</span>
              <button 
                // onClick={onContactClick}
                className="footer-bottom-link"
                type="button"
              >
                Terms of Service
              </button>
            </div>
            <p className="footer-credit">
              Crafted with <Heart size={14} fill="var(--color-like)" className="footer-heart" /> by My Musing
            </p>
          </div>
        </div>
      </div>

      {/* Decorative Background */}
      <div className="footer-background-pattern"></div>
    </footer>
  );
};

export default Footer;